package org.ksdfv.thelema.kxjs

import org.ksdfv.thelema.fs.IFileSystem
import org.ksdfv.thelema.fs.IFile

/** @author zeganstyl */
class JsFS: IFileSystem {
    override val externalStoragePath: String
        get() = ""

    override val isExternalStorageAvailable: Boolean
        get() = false

    override val localStoragePath: String
        get() = ""

    override val isLocalStorageAvailable: Boolean
        get() = false

    override fun file(path: String, location: Int): IFile = JsFile(path)
}
